import React, { useEffect, useRef } from 'react';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import StudentIdCard from './StudentIdCard';
import './style.css';
import { Student, fetchStudents } from '../../store/slices/studentSlice';
import { selectStudents } from '../../store/selectors/studentSelectors';

const AllStudents: React.FC = () => {
  const dispatch = useAppDispatch();
  const students = useAppSelector(selectStudents);
  const { user } = useSelector((state: RootState) => state.auth);
  const loading = useAppSelector((state) => state.students.loading);
  const error = useAppSelector((state) => state.students.error);
  
  // Add ref to track if API call is in progress
  const isFetchingStudentsRef = useRef(false);
  
  useEffect(() => {
    // Always fetch students when component mounts and user is available
    if (user?.id && !isFetchingStudentsRef.current) {
      isFetchingStudentsRef.current = true;
      dispatch(fetchStudents(user.id)).finally(() => {
        isFetchingStudentsRef.current = false;
      });
    }
  }, [dispatch, user?.id]);
  
  if (loading) {
    return <div className="my-students"><h2>Loading students...</h2></div>;
  }
  
  if (error) {
    return <div className="my-students"><h2>Error: {error}</h2></div>;
  }
  
  return (
    <div className="my-students">
      <h2>My Children</h2>
      {students.map((student: Student) => (
        <StudentIdCard
          key={student.id}
          studentId={student.id}
          studentName={student.name}
          studentClass={student.class}
          school={student.school}
          photo={student.photo || '/student.svg'}
          phoneNumber={student.phoneNumber?.replace(/^\+91/, '') || ''}
          year="2026-27"
          principal="President"
          signature="Authorized Signature"
        />
      ))}
    </div>
  );
};

export default AllStudents;